import React, { useState } from "react";
import { PlusIcon, MinusIcon } from "@heroicons/react/24/outline";

const FAQ_DATA = [
  {
    id: 1,
    question: "Apa saja fitur utama yang tersedia di Madrasah Jateng Digital (DIAJENG)?",
    answer:
      "Madrasah Jateng Digital menyediakan fitur ujian digital, secure mode, otomatisasi penilaian, monitoring ujian, serta laporan hasil ujian yang mudah dipantau.",
  },
  {
    id: 2,
    question: "Bagaimana cara kerja Secure Mode di Madrasah Jateng Digital?",
    answer:
      "Secure Mode membantu menjaga pelaksanaan ujian agar lebih aman dengan membatasi aktivitas tertentu selama ujian berlangsung.",
  },
  {
    id: 3,
    question: "Apa keunggulan fitur otomatisasi penilaian di Madrasah Jateng Digital?",
    answer:
      "Fitur otomatisasi penilaian mempercepat proses koreksi dan rekap nilai sehingga guru dapat melihat hasil ujian dengan lebih efisien.",
  },
  {
    id: 4,
    question: "Bagaimana monitoring ujian membantu guru selama pelaksanaan ujian?",
    answer:
      "Monitoring ujian membantu guru memantau aktivitas peserta, progres pengerjaan, dan kondisi pelaksanaan ujian secara lebih terkontrol.",
  },
  {
    id: 5,
    question: "Apa yang ditampilkan dalam laporan hasil ujian Madrasah Jateng Digital?",
    answer:
      "Laporan hasil ujian menampilkan nilai, status pengerjaan, rekap peserta, serta informasi evaluasi yang dibutuhkan oleh guru atau madrasah.",
  },
];

function FAQItem({ faq, index, isOpen, onToggle }) {
  return (
    <div className="rounded-xl bg-white shadow-md transition-shadow hover:shadow-lg">
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-center justify-between gap-4 px-4 py-5 text-left sm:px-6 sm:py-6"
      >
        <span className="flex items-start gap-2 sm:gap-3 flex-1 min-w-0">
          <span className="font-bold text-green-700 shrink-0">{index}.</span>
          <span className="font-semibold text-green-700 text-sm sm:text-base lg:text-lg leading-snug break-words">
            {faq.question}
          </span>
        </span>

        <div className="shrink-0 text-green-700">
          {isOpen ? (
            <MinusIcon className="w-5 h-5 sm:w-6 sm:h-6" />
          ) : (
            <PlusIcon className="w-5 h-5 sm:w-6 sm:h-6" />
          )}
        </div>
      </button>

      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? "max-h-96" : "max-h-0"
        }`}
      >
        <p className="px-4 pb-5 text-sm sm:px-6 sm:pb-6 sm:text-base text-gray-600 leading-relaxed">
          {faq.answer}
        </p>
      </div>
    </div>
  );
}

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="bg-gradient-to-r from-green-900 via-green-800 to-green-600 px-4 py-12 sm:px-6 sm:py-16 md:py-20 lg:px-8">
      <div className="mx-auto max-w-7xl max-w-[1680px]">
        <div className="grid gap-8 lg:gap-12 lg:grid-cols-2">
          {/* Left Section */}
          <div className="flex flex-col justify-start lg:sticky lg:top-8 h-fit">
            <div className="rounded-xl border border-white/20 bg-white/10 p-6 sm:p-8 backdrop-blur-sm">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
                Pertanyaan yang Sering Diajukan
              </h2>

              <p className="mt-3 sm:mt-4 text-sm sm:text-base lg:text-lg text-white/80 leading-relaxed">
                Beberapa pertanyaan umum mengenai platform Madrasah Jateng Digital
              </p>

              <button className="mt-8 sm:mt-10 w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 rounded-lg bg-white font-bold text-green-700 hover:bg-green-50 transition text-sm sm:text-base">
                Hubungi Team Support
              </button>
            </div>
          </div>

          {/* Right Section - FAQ List */}
          <div className="space-y-3 sm:space-y-4">
            {FAQ_DATA.map((faq, idx) => (
              <FAQItem
                key={faq.id}
                faq={faq}
                index={idx + 1}
                isOpen={openIndex === idx}
                onToggle={() => setOpenIndex(openIndex === idx ? null : idx)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQ;
